module.exports = ".container {\n    width: 100%;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/organization/components/organization-details/organization-details-edit/add-domain/add-domain.component.css
// module id = ./src/app/organization/components/organization-details/organization-details-edit/add-domain/add-domain.component.css
// module chunks = main